export const BUILD_VERSION = '2d3bbbab45ac55b3cfab9fc3c778d2602616015b';
